import React, { useState, useEffect } from "react";
import axios from "axios";
import { MAPBOX_ACCESS_TOKEN } from "../../../../config/mapbox";
import classes from "./MapSearch.module.css";
import { LOCATION_SEARCH_BOX_PLACEHOLDER } from "../../../../constants/app";

const MapSearch = (props) => {
	const [search, setSearch] = useState();
	const [result, setResult] = useState([]);

	useEffect(() => {
		// The address comes from the user when clicks on the map
		setSearch(props.value);
	}, [props.value]);

	const onSearch = (value) => {
		setSearch(value);

		// Restrict the search for this location
		const californiaBbox = [-124.410607, 32.534231, -114.134458, 42.009659];
		const countryFilter = 'us';
		axios
			.get(
				`https://api.tiles.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
					value
				)}.json?bbox=${californiaBbox}&country=${countryFilter}&access_token=${MAPBOX_ACCESS_TOKEN}`
			)
			.then((result) => {
				const californiaResults = result.data.features.filter(feature => {
					return feature.place_name.includes('California')
				})
				setResult(californiaResults);
			});
	}

	const clearSearch = () => {
		setSearch("");
	}

	const selectLocation = (item) => {
		setSearch(item.place_name);
		setResult([]);
		props.flyTo(item);
	};

	return (
		<div style={{ position: "relative" }}>
			<div style={props.style} className={classes.container}>
				<i className={`fa fa-search ${classes.searchIcon}`} />

				<input
					type="text"
					placeholder={LOCATION_SEARCH_BOX_PLACEHOLDER}
					value={search}
					onChange={(event) => onSearch(event.target.value)}
				/>

				{result.length || search ? (
					<i
						className={`fa fa-close ${classes.closeIcon}`}
						onClick={clearSearch}
					/>
				) : null}
			</div>

			{result.length && search.length >= 2 ? (
				<ul
					style={{
						...props.style,
						top: `${parseInt(props.style.top, 10) + 53}px`
					}} className={classes.autocompleteResult}>
					{result.map((item) => {
						return (
							<li
								key={item.id}
								onClick={() => selectLocation(item)}
							>
								{item.place_name}
							</li>
						);
					})}
				</ul>
			) : null}
		</div>

	);
};

export default MapSearch;